import React from "react";
import t from "../../../helpers/t";
import Biscuit from "../../../../utils/Biscuit";
const NewLocationButtton = (props) => {
  return (
    <>
      <a
        href={"/locations/add"}
        id="inb-c-left-bar-add-contingent"
        className={"button beautify beautify-" + Biscuit.get("user.client_id")}
        style={{ width: "300px" }}
      >
        <i className="fi fi-page-add"></i>
        <span>{t("add_${a}", { a: t("location") })}</span>
      </a>
    </>
  );
};
export default NewLocationButtton;
